<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>

                <gameTab @changeTabGame="changeTabGame"></gameTab>


                <div class=" row p-list-representation-data w-100">
                  <contentList
                  @submitData="submitData"



                  :selected-player="selectedPlayer"
                  :selected-cup="selectedCup"

                  :players-data="playersData"
                  :cups-data="cupsData"
                  :page="page"
                  :form-data="formData"
                  ></contentList>
                </div>

              </div>

          </div>

        <tableContent :page="page" :table-data="tableData" @paganationChangePage="paganationChangePage" ></tableContent>
      </Loader>
  </div>
</template>

<script>
import contentList from '../components/Team/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/Team/tableContent';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';
import gameTab from '../components/gameFuture/gameTab';



export default {
  name: "Team",
  components: {
    contentList,
    appHeader,
    tableContent,
    gameTab,
  },

  props: {

  },

  data() {
    return {
      loading                                 : true,
      updateCitySelected                      : 0,
      page                                    : 0,
      checkEmptyCity                     : 'default',
      formData   : {
        name            : '',
        slogan          : '',
        birth_date      : '',
        mobile          : '',
        national_code   : '',
        full_name       : '',
        creator_image   : '',

        cup_id          : '',
        player_id       : '',

        include_owner   : 1,
        include_players : 1,
        include_cup     : 1,
        per_page        : 10,
        page            :  1,
      },
      tableData                               : [],
      page                                    : 1,
      statusRunPaganation                     : true,
      resetPagePaganation                     : 0,
      cupsData                                : [

      ],
      playersData                             : [

      ],
      selectedPlayer : {

      },
      selectedCup : {

      },
      statusGetCupAndGetPlayer : false,


    }
  },

  watch: {
    statusGetCupAndGetPlayer(){
      this.getCupAndGetPlayer();
    }

  },

  created() {

  },


  mounted() {
    this.getTableData();
  },


  methods: {
    updateTableData(page){
      this.loading                                 = true;
      this.formData.page                           = page;
      this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';
      this.getTableData();
    },

    paganationChangePage(page){
      this.page = page;
      this.updateTableData(page);
    },


    getTableData(){
      this.loading      = true;

      this.$store
      .dispatch('teams/getTableData', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading                  = false;
        this.tableData                = res.data;
        this.statusGetCupAndGetPlayer = true;
      })
    },

    submitData(data){
      this.formData     = data;
      this.loading      = true;


      this.$store
      .dispatch('teams/newAndEditDataTeam', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading      = false;
      })
    },

    getCupAndGetPlayer(data){
      this.loading      = true;

      this.$store
      .dispatch('teams/getCupAndGetPlayer', {

      })
      .then((res)=>{
        this.loading      = false;
        this.cupsData     = res.allCups.data;
        this.playersData  = res.allPlayers.data;
        // this.selectedPlayer = {id:1,name:'player',title:'player'}
        // this.selectedCup    ={id:1,name:'cup',title:'cup'}
      })
    },

    changeTabGame(data){
      
    }





  }


}
</script>
